import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import NumberInput from "../../../../components/inputs/number";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,

		//formState
		errors,
		isSubmitting,

		loading,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		// setLoading,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(
						handleOnSubmit
						// handleOnError
					)}
				>
					<main>
						<div className="row">
							<TextInput
								label="Tipo colaborador"
								id="nome"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
								className="col-12"
							/>
							<TextInput
								label="Observação"
								id="obs"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
							/>
							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_type"
										type="checkbox"
										{...register("ativo")}
									/>
									<label htmlFor="ativo_type">
										<span className="text-sm">Ativar Tipo Colaborador</span>
									</label>
								</div>
							</div>
						</div>
					</main>
					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;
